import { http } from "../../../config/HttpMethod";
import { ESP_ENDPOINTS } from "../endpoints";

export const getCasingOD = async () => {
  try {
    const response = await http.get(`${ESP_ENDPOINTS?.GET_CASING_OD}`);
    return response?.data;
  } catch (err) {
    console.log(err, "error");
  }
};

export const getCasingWeightList = async (
  casingWeightUnit: number,
  casingOD: number
) => {
  try {
    const params = { casingOD: casingOD, casingWeightUnit: casingWeightUnit };
    const response = await http.get(
      `${ESP_ENDPOINTS?.GET_CASING_WEIGHT_LIST}`,
      { params }
    );
    return response?.data;
  } catch (error) {
    console.log(error, "error");
  }
};

export const getCasingDriftID = async (
  casingIDUnit: number,
  casingWeightUnit: number,
  casingOD: number,
  casingWeight: number
) => {
  try {
    const params = {
      casingIDUnit: casingIDUnit,
      casingOD: casingOD,
      casingWeightUnit: casingWeightUnit,
      casingWeight: casingWeight,
    };
    const response = await http.get(`${ESP_ENDPOINTS?.GET_CASING_DRIFT_ID}`, {
      params,
    });
    return response?.data;
  } catch (error) {
    console.log(error, "error");
  }
};

export const getCasingID = async (
  casingIDUnit: number,
  casingWeightUnit: number,
  casingOD: number,
  casingWeight: number
) => {
  try {
    const params = {
      casingIDUnit: casingIDUnit,
      casingOD: casingOD,
      casingWeightUnit: casingWeightUnit,
      casingWeight: casingWeight,
    };
    const response = await http.get(`${ESP_ENDPOINTS?.GET_CASING_ID}`, {
      params,
    });
    return response?.data;
  } catch (error) {
    console.log(error, "error");
  }
};

export const getLinerODList = async (casingOD: number) => {
  try {
    const params = {
      casingOD: casingOD,
    };
    const response = await http.get(`${ESP_ENDPOINTS?.GET_LINER_OD_LIST}`, {
      params,
    });
    return response?.data;
  } catch (error) {
    console.log(error, "error");
  }
};

export const getLinerWeightList = async (
  linerWeightUnit: number,
  linerOD: number
) => {
  try {
    const params = {
      linerWeightUnit: linerWeightUnit,
      linerOD: linerOD,
    };
    const response = await http.get(
      `${ESP_ENDPOINTS?.GET_LINER_WEIGHT_LIST}`,
      {
        params,
      }
    );
    return response?.data;
  } catch (error) {
    console.log(error, "error");
  }
};

export const getLinerID = async (
  linerIDUnit: number,
  linerWeightUnit: number,
  linerOD: number,
  linerWeight: number
) => {
  try {
    const params = {
      linerIDUnit: linerIDUnit,
      linerWeightUnit: linerWeightUnit,
      linerOD: linerOD,
      linerWeight: linerWeight,
    };
    const response = await http.get(`${ESP_ENDPOINTS?.GET_LINER_ID}`, {
      params,
    });
    return response?.data;
  } catch (error) {
    console.log(error, "error");
  }
};

export const getTubingID = async (
  tubingIDUnit: number,
  tubingWeightUnit: number,
  tubingOD: number,
  tubingWeight: number
) => {
  try {
    const params = {
      tubingIDUnit: tubingIDUnit,
      tubingWeightUnit: tubingWeightUnit,
      tubingOD: tubingOD,
      tubingWeight: tubingWeight,
    };
    const response = await http.get(`${ESP_ENDPOINTS?.GET_TUBING_ID}`, {
      params,
    });
    return response?.data;
  } catch (error) {
    console.log(error, "error");
  }
};

export const getTubingWeightList = async (
  tubingWeightUnit: number,
  tubingTypeUpset: number,
  tubingOD: number,
) => {
  try {
    const params = {
      tuningOD: tubingOD,
      tubingWeightUnit: tubingWeightUnit,
      tubingTypeUpset: tubingTypeUpset,
    };
    const response = await http.get(`${ESP_ENDPOINTS?.GET_TUBING_WEIGHT_LIST}`, {
      params,
    });
    return response?.data;
  } catch (error) {
    console.log(error, "error");
  }
};
